import React from 'react'

import classNames from './ConfirmButtons.css'

export default function ConfirmButtons ({
  cancelText = 'Cancel',
  confirmText = 'Save',
  onCancel = function () {},
  onConfirm = function () {},
  confirmDisabled = false,
  confirmDisabledText = null,
  confirmHidden = false,
  middleButtons = [],
  appendButtons = []
}) {
  const renderButton = button => (
    <button
      key={button.text}
      type='button'
      className={button.text === 'Save' ? classNames.confirmButton : classNames.button}
      onClick={button.onClick}
      disabled={button.disabled}>
      {button.text}
    </button>
  )
  return (
    <div className={classNames.buttons}>
      <button
        type='button'
        className={classNames.cancelButton}
        onClick={onCancel}>
        {cancelText}
      </button>
      {middleButtons.map(renderButton)}
      {!confirmHidden &&
        <button
          type='button'
          className={classNames.confirmButton}
          onClick={onConfirm}
          disabled={confirmDisabled}>
          {confirmDisabled && confirmDisabledText || confirmText}
        </button>
      }
      {appendButtons.map(renderButton)}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ConfirmButtons.js